//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapState, mapMutations} from 'vuex'

export default {
  name: '',
  data() {
    return {
      popOption: {boundariesElement: 'body'},
      cid: this.$route.query.cid
    }
  },
  mounted() {
    this.popoverRef = this.menu.id;
  },
  props: ['menu'],
  computed: {
    ...mapState(['campaign'])
  },
  methods: {
    ...mapMutations({
      changePage: 'CHANGE_PAGE',
      initSearchKeyword: 'SEARCH_KEYWORD',
    }),
    changeBreadCrumb(menuName, childrenName) {
      if (childrenName) {
        this.changeBreadCrumb([menuName, childrenName])
      } else {
        this.changeBreadCrumb([menuName])
      }
    },
    doCatSelect(menu) {
      this.changePage(1)
      this.initSearchKeyword('')
      this.$router.push({
        path: `/home/${this.cid}`,
        query: {type: menu.id, cid: this.cid}
      })
    },
    menuRoute(menu, item) {
      this.changePage(1)
      this.initSearchKeyword('')
      this.$router.push({
        path: `/home/${this.$route.query.cid}`,
        query: {cid: this.$route.query.cid, type: menu.id, cat: item.id}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/menu/Type.vue